import React, { ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

import { Tooltip } from '../tooltip/index';

/**
 * Both cells clip to a fixed width, so long labels and values (e.g. "Post-money valuation cap")
 * render as "Post-money valuat…". `Tooltip` measures the span on hover and only opens when the
 * text is actually ellipsized, so a cell that already fits is left alone.
 */
export const SummaryItem = ({
  title,
  value,
  titleClassName,
  className,
  titleWrapperClassName,
  valueClassName,
}: {
  className?: false | string;
  title: ReactNode;
  titleClassName?: string;
  titleWrapperClassName?: string;
  value: number | ReactNode | string | undefined;
  valueClassName?: string;
}) => (
  <div className={twMerge('flex w-full gap-3 py-3', className)}>
    <div className={twMerge('flex', titleWrapperClassName)}>
      <Tooltip content={title}>
        <span
          className={twMerge(
            'w-[120px] flex-shrink-0 truncate text-xs font-[450] text-gray-500',
            titleClassName,
          )}
        >
          {title}
        </span>
      </Tooltip>
      <span className="text-xs font-[450] text-gray-500">:</span>
    </div>
    <Tooltip content={value}>
      <span
        className={twMerge(
          'max-w-[250px] truncate text-xs font-[450] text-gray-700',
          valueClassName,
        )}
      >
        {value}
      </span>
    </Tooltip>
  </div>
);
